export enum ApplicationState {
	IDLE,
	LOADING,
	READY,
	ERROR,
}
